module.exports = __webpack_public_path__ + "img/logo.f0b6872d.png";